import c from "../common";

export default {
  SmsMsg: "Dear user, your verification code is: ",

  Step1_title: "Email Verification",
  Step2_title: "Account Information",
  Step3_title: "Two Factor Authentication",

  FirstTimeWarning: "Please use a computer for your first registration and a mobile device for authentication",
  PhoneReady: "Please ready your Business mobile phone for registration.",

  "Sent-Msg_1.1": "The verification pin have been sent to ",
  "Sent-Msg_1.2": " . ",
  "Sent-Msg_1.3": "Verification code incorrect.",

  "Sent-Msg_2.1": "The email have been registered.",
  "Sent-Msg_2.3": "Login now",

  Email_alert: "This email have been registered. Please re-enter.",
  Email_alert2: "Re-enter",

  MobilePhone: "Phone number (optional)",
  phone_rule1: "Please enter 8 digit phone number.",
  phone_rule2: "Phone number can only be Arabic numerals.",
  phone_rule3: "Phone number cannot contain space.",

  getPin: "Get Pin",
  second: "Second",

  V_Code: c.V_Code.en + ":",
  Pin_rule1: "Please enter 4 digit Pin Code",
  Pin_rule2: "Please enter only numbers.",
  Confirm: c.Confirm.en,

  NamePIC: "User name",
  entername: "Please enter name",

  emailPIC: "Email",
  enterEmail: "Please enter valid email",

  pwPIC: "Password",
  enterPw: "Please enter password with 9-16 digits.",
  rule_pw: "No space is allowed.",

  repeatPw: "Repeat password",
  reEnterPw: "Please re-enter password",
  unmatchPw: "The two passwords you entered do not match.",

  //2FA-GA
  step1: "1. Download the Google Authenticator App",
  step2: "2. Set up Account",
  step3: "3. Verification",
  step4: "4. Complete",
  mustdo: "*Must be downloaded and installed",

  //2FA step 1
  GAtitle: "Google Authenticator App Download Link",
  withphone: "(*Please scan the QR code with your mobile phone)",

  LinkTitleAnd: " Google Play download link (Andriod)",
  LinkTitleIos: " App Store download link (IOS)",

  "step1-2": " Download Google Authenticator ",
  "1-2GP": "Click to download at Google Play",
  "1-2AS": "Click to download at App Store",

  next: c.next.en,
  previous: c.previous.en,

  //2FA step2
  "step2-1": "1. Open Google Authenticator",
  "step2-2": "2. Click「Get started」",
  "step2-3": "3. Click「Scan a QR code」to open the scanner from your phone",

  //2FA step3
  "step3-1": "1. Scan your QR code",
  "step3-1hide": "Hide",
  "step3-1show": "Show",
  "step3-1generate": "generate code",

  "step3-2": "2. Please enter the 6 digit under 「" + c.appName.en.uppercase + "」",
  "step3-2wrong": "Incorrect Verification Code",
  "step3-2req": "Please enter 6 digit Verification Code.",
  "step3-2rule": "Please enter only numbers.",

  //2FA step4 (complete page)
  CompleteAC: "Registration Complete! ",
  OpenAcNow: "Open Merchain Now",
  EnterDash: "Get Started",

  description_1: "Welcome to " + c.appName.en.uppercase,
  description_2: c.appName.en.uppercase,
};
